module.exports = __webpack_public_path__ + "static/media/HanwhaPanel.33dab614.png";